import React, { useState } from 'react';
import './_Cycle.scss';

const Cycle: React.FC = ({ children }) => {
  const [activeItem, setActiveItem] = useState<number>(0);
  const itemsCount = React.Children.count(children);

  const bindCarouselControl = (step: number) => {
    return () => {
      if (validateNextStep(step)) {
        setActiveItem(activeItem + step);
      }
    };
  };

  const validateNextStep = (step: number) => {
    const nextStep = activeItem + step;

    return nextStep < itemsCount && nextStep > -1;
  };

  return (
    <div className="cycle">
      <div className="cycle__playground">
        {React.Children.map(children, (child, index) => (
          <div
            className={`cycle__item${index === activeItem ? ` cycle__item--active` : ''}`}
            key={`admin-cycle-item-${index}`}>
            {child}
          </div>
        ))}
      </div>

      {itemsCount > 1 && (
        <div className="cycle__controls">
          <button
            type="button"
            className={`cycle__controls--prev${validateNextStep(-1) ? '' : ' cycle__controls--disabled'}`}
            onClick={bindCarouselControl(-1)}
          />
          <span className="cycle__controls--count">{activeItem}</span>
          <button
            type="button"
            className={`cycle__controls--next${validateNextStep(1) ? '' : ' cycle__controls--disabled'}`}
            onClick={bindCarouselControl(1)}
          />
        </div>
      )}
    </div>
  );
};
export default Cycle;
